// components/ProtectedRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { hasRouteAccess, getDefaultRedirectPath } from "../utils/rbac";
import tokenManager from "../utils/tokenManager";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const user = tokenManager.getUser();

  console.log("use", user);

  // If user is not logged in, redirect to login
  const isAuthenticated = tokenManager.isAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has access to this route
  const hasAccess = hasRouteAccess(location.pathname, user);

  if (!hasAccess) {
    // Redirect to user's default allowed page
    const redirectPath = getDefaultRedirectPath(user);
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
